import {Injectable} from 'ng-metadata/core';
import {AbstractRequest} from '../abstractRequest';
import {FormBuilderEnums} from '../../../../../../../infra/formBuilder/formBuilder.service';

@Injectable()
export class AlmaRequestOther extends AbstractRequest{


    constructor() {
        super();
        this.formFields = [
            {
                key: 'hold-or-booking',
                name: 'requestType',
                label: 'almaRequest.requestType',
                value: 'hold',
                path: 'groups-list-map/requestType',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN,

                populator:  {
                    params:     {
                        defaultValue: FormBuilderEnums.FIRST
                    }
                },
                options:[
                    {
                        label:'almaRequest.requestType.hold',
                        value:'hold'
                    }
                ],
                events: {
                    onClick: this.onClick.bind(this),
                    params: []
                }

            },{
                key: 'manualDescription',
                name: 'manualDescription',
                label: 'almaRequest.manualDescription',
                mandatory: true,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },{
                key: 'pickupInstitutionFulNet',
                name: 'pickupInstitutionFulNet',
                path: 'ful-net-request-other-groups-list-map/pickupInstitutionFulNet',
                label: 'almaRequest.pickupInstitution',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        byCategory: 'category',
                        filters :['pickupLocationFulNet']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            },{
                key: 'pickupLocationFulNet',
                name: 'pickupLocationFulNet',
                path: 'ful-net-request-other-groups-list-map/pickupLocationFulNet',
                label: 'almaRequest.pickupLocation',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        byCategory: 'category',
                        filters :['pickupInstitutionFulNet']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                },
                dependOn: {key : 'requestType', value: ['booking','hold']}
            },{
                key: 'pickupLocation',
                name: 'pickupLocation',
                path: 'pickupLocation',
                label: 'almaRequest.pickupLocation',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        byCategory: 'category',
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            },
            {
                key: 'notNeedAfter',
                name: 'lastInterestDate',
                label: 'almaRequest.notNeedAfter',
                existingPath: 'hasHold',
                fieldType: FormBuilderEnums.FIELD_TYPE.DATE,
                uiType: FormBuilderEnums.UI_TYPE.DATE,
                minDate: 'now',
                dependOn: {key : 'requestType', value: 'hold'},
                populator:  {
                    params:     {
                        allow       : FormBuilderEnums.FUTURE_DATES
                    }
                }
            },
            {
                key: 'comment',
                name: 'comment',
                label: 'almaRequest.comment',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },{
                key: 'instCode',
                name: 'instCode',
                label: 'almaRequest.institutionCode',
                mandatory: true,
                valuePath: 'instCode',
                existingPath: 'instCode',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },{
                key: 'pickupLocation',
                name: 'pickupLocation',
                label: 'almaRequest.pickupLocation',
                mandatory: false,
                valuePath: 'pickupLocation',
                existingPath: 'pickupLocation',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },{
                key: 'callNumber',
                name: 'callNumber',
                label: 'almaRequestOther.callNumber',
                mandatory: true,
                valuePath: 'callNumber',
                existingPath: 'callNumber',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },{
                key: 'holdingKey',
                name: 'holdingKey',
                label: 'almaRequestOther.holdingKey',
                mandatory: true,
                valuePath: 'holdingKey',
                existingPath: 'holdingKey',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/alma/AlmaRequestOther.ts